import React, { useState, useEffect, useCallback } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import apiClient from '../api/axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';

const PublicLibrarySongsPage = () => {
    const [songs, setSongs] = useState([]);
    const [libraryInfo, setLibraryInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { orgId } = useParams();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    const fetchLibrarySongs = useCallback(() => {
        if (!isAuthenticated) return;
        setLoading(true);
        // Сначала получаем информацию о самой библиотеке (ее название)
        apiClient.get(`/organizations/${orgId}`)
            .then(orgResponse => {
                setLibraryInfo(orgResponse.data);
                // Затем загружаем песни
                return apiClient.get(`/public-libraries/${orgId}/songs`);
            })
            .then(songsResponse => {
                setSongs(songsResponse.data);
                setError('');
            })
            .catch(err => {
                setError('Ошибка загрузки песен из общей фонотеки.');
                toast.error('Не удалось загрузить данные фонотеки.');
            })
            .finally(() => {
                setLoading(false);
            });
    }, [orgId, isAuthenticated]);

    useEffect(() => {
        fetchLibrarySongs();
    }, [fetchLibrarySongs]);

    if (loading) {
        return <div className="text-center">Загрузка...</div>;
    }

    if (error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    return (
        <>
            <Button variant="link" onClick={() => navigate(-1)} className="mb-3 ps-0">&larr; Назад к списку фонотек</Button>
            <h1 className="h2">Песни из фонотеки "{libraryInfo?.name}"</h1>
            
            <div className="card mb-4">
                <ul className="list-group list-group-flush">
                    {songs.length > 0 ? (
                        songs.map(song => (
                            <li key={song.id} className="list-group-item d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column">
                                    {/* Ссылка ведет на просмотр песни в контексте ее ID, 
                                        где права доступа будут проверены сервером */}
                                    <Link to={`/songs/${song.id}`} className="fw-bold text-decoration-none">{song.title}</Link>
                                    <small className="text-muted">
                                        Добавлено: {song.created_at ? new Date(song.created_at).toLocaleDateString() : '-'}
                                    </small>
                                </div>
                            </li>
                        ))
                    ) : (
                        <li className="list-group-item text-center">В этой фонотеке пока нет песен.</li>
                    )}
                </ul>
            </div>
        </>
    );
};

export default PublicLibrarySongsPage;
